"use client";

import { useEffect, useState } from "react";
// import NavbarDashboard from "../UserDashboardModule/NavbarDashboard";
import Select from "react-select";
import axios from "axios";
import HeaderMain from "../dasboard-component/Components/HeaderMain";
import { useAuth } from "../context/AuthContext";

// Import sport-specific components
import GolfMatchDetails from "./components/GolfMatchDetails";
import TableTennisMatchDetails from "./components/TableTennisMatchDetails";
import TennisMatchDetails from "./components/TennisMatchDetails";
import SnookerMatchDetails from "./components/SnookerMatchDetails";
import FootballMatchDetails from "./components/FootballMatchDetails";
import BasketballMatchDetails from "./components/BasketballMatchDetails";
import VolleyballMatchDetails from "./components/VolleyballMatchDetails";
import SquashMatchDetails from "./components/SquashMatchDetails";
import SwimmingEventDetails from "./components/SwimmingEventDetails";
import HockeyMatchDetails from "./components/HockeyMatchDetails";
import CricketMatchDetails from "./components/CricketMatchDetails";
import PadelTennisMatchDetails from "./components/PadelTennisMatchDetails";

const ViewGame = () => {
  const [sportsOptions, setSportsOptions] = useState([]);
  const [selectedSport, setSelectedSport] = useState(null);
  const [gameRecords, setGameRecords] = useState([]);
  const [noRecordsMessage, setNoRecordsMessage] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [userNames, setUserNames] = useState({});

  const { user } = useAuth();
  const token = user?.uid;

  // Function to fetch user names by IDs
  const fetchUserNames = async (userIds) => {
    try {
      const idsToFetch = userIds.filter(
        (id) => id && id !== "guest" && !userNames[id]
      );
      if (idsToFetch.length === 0) return;

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/user-add-game/api/selection/user-names`,
        {
          params: {
            userIds: idsToFetch.join(","),
          },
          withCredentials: true,
        }
      );

      setUserNames((prev) => ({ ...prev, ...response.data }));
    } catch (error) {
      console.error("Error fetching user names:", error);
    }
  };

  // Styles matching Selection.jsx
  const styles = {
    container: {
      maxWidth: "800px",
      margin: "20px auto",
      padding: "20px",
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    sectionTitle: {
      fontSize: "clamp(18px, 4vw, 24px)",
      fontWeight: "600",
      color: "#2c3e50",
      marginBottom: "15px",
      textAlign: "center",
      position: "relative",
      paddingBottom: "10px",
    },
    titleUnderline: {
      content: "''",
      position: "absolute",
      bottom: "0",
      left: "50%",
      transform: "translateX(-50%)",
      width: "80px",
      height: "3px",
      backgroundColor: "#3498db",
      borderRadius: "2px",
    },
    selectWrapper: {
      marginBottom: "30px",
    },
    selectionStep: {
      backgroundColor: "#f8fafc",
      borderRadius: "12px",
      padding: "clamp(15px, 4vw, 25px)",
      marginBottom: "15px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      border: "1px solid #e2e8f0",
    },
    stepNumber: {
      display: "inline-block",
      width: "clamp(26px, 5vw, 30px)",
      height: "clamp(26px, 5vw, 30px)",
      backgroundColor: "#3498db",
      color: "white",
      borderRadius: "50%",
      textAlign: "center",
      lineHeight: "clamp(26px, 5vw, 30px)",
      marginRight: "10px",
      fontWeight: "bold",
      fontSize: "clamp(12px, 3vw, 16px)",
    },
    stepTitle: {
      display: "inline-block",
      fontSize: "clamp(16px, 3.5vw, 20px)",
      fontWeight: "600",
      color: "#2c3e50",
      marginBottom: "15px",
    },
    gameRecordCard: {
      backgroundColor: "#f8fafc",
      border: "1px solid #e2e8f0",
      borderRadius: "12px",
      padding: "clamp(15px, 4vw, 25px)",
      marginBottom: "15px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      transition: "all 0.3s ease",
    },
    gameRecordHeader: {
      borderBottom: "2px solid #e2e8f0",
      paddingBottom: "12px",
      marginBottom: "12px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "10px",
    },
    gameRecordTitle: {
      fontSize: "clamp(16px, 3.5vw, 18px)",
      fontWeight: "600",
      color: "#2c3e50",
    },
    gameRecordId: {
      fontSize: "clamp(12px, 2.5vw, 14px)",
      color: "#718096",
    },
    gameRecordInfo: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "12px",
      marginBottom: "15px",
    },
    infoLabel: {
      fontWeight: "600",
      color: "#2c3e50",
      marginRight: "6px",
    },
    infoValue: {
      color: "#4a5568",
    },
    viewButton: {
      padding: "10px 24px",
      fontSize: "clamp(14px, 3vw, 16px)",
      backgroundColor: "#3498db",
      color: "white",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "600",
      boxShadow: "0 4px 6px rgba(52, 152, 219, 0.3)",
      transition: "all 0.3s ease",
    },
    noRecordsMessage: {
      color: "#e74c3c",
      fontWeight: "500",
      textAlign: "center",
      padding: "15px",
      backgroundColor: "#fdf2f2",
      borderRadius: "8px",
      marginTop: "20px",
      border: "1px solid #fed7d7",
      fontSize: "clamp(13px, 2.5vw, 15px)",
    },
    infoMessage: {
      color: "#718096",
      fontWeight: "500",
      textAlign: "center",
      padding: "15px",
      backgroundColor: "#f7fafc",
      borderRadius: "8px",
      marginTop: "20px",
      border: "1px solid #e2e8f0",
      fontSize: "clamp(13px, 2.5vw, 15px)",
    },
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
      backdropFilter: "blur(4px)",
      padding: "8px",
    },
    modalContent: {
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      width: "100%",
      maxWidth: "900px",
      maxHeight: "95vh",
      boxShadow: "0 8px 30px rgba(0,0,0,0.3)",
      position: "relative",
      display: "flex",
      flexDirection: "column",
    },
    modalHeader: {
      borderBottom: "2px solid #3498db",
      padding: "clamp(16px, 4vw, 24px)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    modalTitle: {
      fontSize: "clamp(18px, 4vw, 24px)",
      fontWeight: "600",
      color: "#2c3e50",
      paddingRight: "8px",
    },
    closeButton: {
      backgroundColor: "#e74c3c",
      color: "white",
      border: "none",
      borderRadius: "50%",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "20px",
      fontWeight: "bold",
      cursor: "pointer",
      boxShadow: "0 2px 6px rgba(231, 76, 60, 0.3)",
      transition: "all 0.3s ease",
      flexShrink: 0,
    },
    modalBody: {
      flex: 1,
      overflowY: "auto",
      padding: "clamp(16px, 4vw, 24px)",
    },
    modalDetailsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "15px",
      marginBottom: "24px",
    },
    sectionHeading: {
      marginBottom: "15px",
      borderBottom: "1px solid #e2e8f0",
      paddingBottom: "12px",
      color: "#2c3e50",
      fontSize: "clamp(16px, 3.5vw, 20px)",
      fontWeight: "500",
    },
    modalFooter: {
      borderTop: "1px solid #e2e8f0",
      padding: "clamp(12px, 3vw, 16px)",
      textAlign: "center",
    },
    closeFooterButton: {
      backgroundColor: "#718096",
      color: "white",
      border: "none",
      padding: "10px 24px",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "clamp(14px, 3vw, 16px)",
      fontWeight: "600",
      transition: "all 0.3s ease",
    },
    // Table styles for compatibility with existing components
    setsTable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      borderRadius: "8px",
      overflow: "hidden",
      fontSize: "clamp(12px, 2.5vw, 14px)",
      tableLayout: "fixed",
    },
    tableTh: {
      backgroundColor: "#edf2f7",
      border: "1px solid #cbd5e0",
      padding: "clamp(6px, 2vw, 8px) clamp(8px, 2.5vw, 12px)",
      textAlign: "center",
      fontWeight: "600",
      color: "#2d3748",
      fontSize: "clamp(11px, 2.2vw, 13px)",
      wordWrap: "break-word",
    },
    tableTd: {
      border: "1px solid #e2e8f0",
      padding: "clamp(6px, 2vw, 8px) clamp(8px, 2.5vw, 12px)",
      textAlign: "center",
      color: "#4a5568",
      fontSize: "clamp(11px, 2.2vw, 13px)",
      wordWrap: "break-word",
    },
  };

  useEffect(() => {
    const fetchSportsOptions = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/common/get-sports`,
          { withCredentials: true }
        );

        // Filter out "General" sport and format options
        const formattedOptions = response.data
          .filter((sport) => sport.value !== "General")
          .map((sport) => ({
            value: sport.value,
            label: sport.value,
          }));
        setSportsOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching sports options:", error);
      }
    };
    fetchSportsOptions();
  }, []);

  useEffect(() => {
    const fetchGameRecords = async () => {
      if (!selectedSport) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/user-add-game/api/selection/user-game-records`,
          {
            params: {
              userId: token,
              sport: selectedSport,
            },
            withCredentials: true,
          }
        );

        if (response.data && response.data.data) {
          const { data, message } = response.data;
          if (data.length === 0) {
            setNoRecordsMessage(
              message || `No game records found for ${selectedSport}`
            );
            setGameRecords([]);
          } else {
            setGameRecords(data);
            setNoRecordsMessage("");
          }
        } else {
          setNoRecordsMessage(`No game records found for ${selectedSport}`);
          setGameRecords([]);
        }
      } catch (error) {
        console.error("Error fetching user game records:", error);
        setNoRecordsMessage("Failed to fetch game records");
        setGameRecords([]);
      }
    };
    fetchGameRecords();
  }, [selectedSport, token]);

  const handleViewDetails = async (record) => {
    setSelectedRecord(record);
    setShowModal(true);

    // Fetch user names for all sports that store player IDs
    try {
      const results =
        typeof record.results === "string"
          ? JSON.parse(record.results)
          : record.results;

      // Handle different data structures - some sports store as arrays, others as single objects
      let matches;
      if (Array.isArray(results)) {
        matches = results;
      } else {
        matches = [results];
      }

      const allUserIds = [];

      matches.forEach((match) => {
        // Golf player IDs - handle both direct match and nested structure
        if (match?.player1?.playerId && match.player1.playerId !== "guest") {
          allUserIds.push(match.player1.playerId);
        }
        if (match?.player2?.playerId && match.player2.playerId !== "guest") {
          allUserIds.push(match.player2.playerId);
        }

        // Snooker player IDs
        if (match?.playerA && match.playerA !== "guest")
          allUserIds.push(match.playerA);
        if (match?.playerB && match.playerB !== "guest")
          allUserIds.push(match.playerB);

        // Tennis player IDs (singles)
        if (match?.playerAId && match.playerAId !== "guest")
          allUserIds.push(match.playerAId);
        if (match?.playerBId && match.playerBId !== "guest")
          allUserIds.push(match.playerBId);

        // Tennis/Table Tennis doubles team IDs
        if (match?.teamA) {
          if (match.teamA.player1Id && match.teamA.player1Id !== "guest")
            allUserIds.push(match.teamA.player1Id);
          if (match.teamA.player2Id && match.teamA.player2Id !== "guest")
            allUserIds.push(match.teamA.player2Id);
        }
        if (match?.teamB) {
          if (match.teamB.player1Id && match.teamB.player1Id !== "guest")
            allUserIds.push(match.teamB.player1Id);
          if (match.teamB.player2Id && match.teamB.player2Id !== "guest")
            allUserIds.push(match.teamB.player2Id);
        }

        // Padel Tennis teams
        if (match?.teamA) {
          if (match.teamA.player1) allUserIds.push(match.teamA.player1);
          if (match.teamA.player2) allUserIds.push(match.teamA.player2);
        }
        if (match?.teamB) {
          if (match.teamB.player1) allUserIds.push(match.teamB.player1);
          if (match.teamB.player2) allUserIds.push(match.teamB.player2);
        }

        // Basketball, Football, Volleyball teams
        if (match?.userTeam) {
          match.userTeam.forEach((player) => {
            if (player.userId) allUserIds.push(player.userId);
          });
        }
        if (match?.opponentTeam) {
          match.opponentTeam.forEach((player) => {
            if (player.userId) allUserIds.push(player.userId);
          });
        }

        // Squash player IDs
        if (match?.playerAId && match.playerAId !== "guest")
          allUserIds.push(match.playerAId);
        if (match?.playerBId && match.playerBId !== "guest")
          allUserIds.push(match.playerBId);

        // Swimming participant IDs
        if (match?.participants) {
          match.participants.forEach((participant) => {
            if (participant.userId && participant.userId !== "guest") {
              allUserIds.push(participant.userId);
            }
          });
        }
        if (match?.relayTeams) {
          match.relayTeams.forEach((team) => {
            if (team.swimmers) {
              team.swimmers.forEach((swimmer) => {
                if (swimmer.userId && swimmer.userId !== "guest") {
                  allUserIds.push(swimmer.userId);
                }
              });
            }
          });
        }

        // Hockey team player IDs
        if (match?.team1Players) {
          match.team1Players.forEach((player) => {
            if (player.userId && player.userId !== "guest") {
              allUserIds.push(player.userId);
            }
          });
        }
        if (match?.team2Players) {
          match.team2Players.forEach((player) => {
            if (player.userId && player.userId !== "guest") {
              allUserIds.push(player.userId);
            }
          });
        }

        // Cricket team player IDs
        if (match?.team1Players) {
          match.team1Players.forEach((player) => {
            if (player.userId && player.userId !== "guest") {
              allUserIds.push(player.userId);
            }
          });
        }
        if (match?.team2Players) {
          match.team2Players.forEach((player) => {
            if (player.userId && player.userId !== "guest") {
              allUserIds.push(player.userId);
            }
          });
        }
      });

      // Remove duplicates and fetch names
      const uniqueUserIds = [
        ...new Set(allUserIds.filter((id) => id && id !== "guest")),
      ];
      if (uniqueUserIds.length > 0) {
        await fetchUserNames(uniqueUserIds);
      }
    } catch (error) {
      console.error("Error processing match data:", error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedRecord(null);
  };

  // Handle ESC key press to close modal
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Escape" && showModal) {
        closeModal();
      }
    };

    if (showModal) {
      document.addEventListener("keydown", handleKeyPress);
      // Prevent body scrolling when modal is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
      document.body.style.overflow = "unset";
    };
  }, [showModal]);

  // Handle click outside modal to close
  const handleModalBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Render different game details based on sport type
  const renderGameDetails = (results) => {
    // Parse results if it's a string
    const parsedResults =
      typeof results === "string" ? JSON.parse(results) : results;

    // Handle different data structures - sometimes it's nested in arrays
    let firstMatch;
    if (Array.isArray(parsedResults)) {
      firstMatch = parsedResults[0];
    } else {
      firstMatch = parsedResults;
    }

    console.log("First match data:", firstMatch);
    console.log("Sport type:", selectedRecord?.sports_name);

    // Golf Detection - check for golf-specific properties
    if (
      firstMatch[0]?.player1 &&
      firstMatch[0]?.player2 &&
      firstMatch[0]?.pars &&
      firstMatch[0]?.holes !== undefined
    ) {
      return (
        <GolfMatchDetails
          games={firstMatch}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    // Hockey Detection (must come before generic team sports detection)
    else if (
      firstMatch?.team1Players &&
      firstMatch?.team2Players &&
      firstMatch?.periods &&
      firstMatch?.goalEvents !== undefined
    ) {
      return (
        <HockeyMatchDetails
          matches={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    // Team Sports Detection
    else if (
      firstMatch?.goalEvents !== undefined ||
      firstMatch?.penaltyEvents !== undefined
    ) {
      return (
        <FootballMatchDetails
          matches={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    } else if (
      firstMatch?.quarters !== undefined &&
      firstMatch?.scoringEvents !== undefined
    ) {
      return (
        <BasketballMatchDetails
          matches={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    } else if (
      firstMatch?.pointEvents !== undefined &&
      firstMatch?.substitutions !== undefined
    ) {
      return (
        <VolleyballMatchDetails
          matches={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    // Table Tennis Detection (before Tennis to avoid conflicts)
    else if (
      firstMatch?.matchType &&
      firstMatch?.games &&
      firstMatch?.userGames !== undefined
    ) {
      return (
        <TableTennisMatchDetails
          matches={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    // Padel Tennis Detection (specific to padel)
    else if (
      firstMatch?.sets &&
      firstMatch?.gameMode === "doubles" &&
      (firstMatch?.teamA !== undefined || firstMatch?.teamB !== undefined)
    ) {
      return (
        <PadelTennisMatchDetails
          matches={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    // Regular Tennis Detection
    else if (firstMatch?.sets && firstMatch?.gameMode !== undefined) {
      return (
        <TennisMatchDetails
          matches={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    // Snooker Detection
    else if (firstMatch?.gameType && firstMatch?.attempts !== undefined) {
      return (
        <SnookerMatchDetails
          games={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    // Squash Detection
    else if (
      firstMatch?.bestOf &&
      firstMatch?.pointsToWin &&
      firstMatch?.playerA !== undefined &&
      firstMatch?.playerB !== undefined
    ) {
      return (
        <SquashMatchDetails
          matches={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    // Swimming Detection
    else if (
      firstMatch?.eventType &&
      firstMatch?.stroke &&
      firstMatch?.distance &&
      (firstMatch?.participants || firstMatch?.relayTeams)
    ) {
      return (
        <SwimmingEventDetails
          events={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    // Cricket Detection
    else if (
      firstMatch?.team1Players &&
      firstMatch?.team2Players &&
      firstMatch?.innings &&
      firstMatch?.tossWinner
    ) {
      return (
        <CricketMatchDetails
          matches={parsedResults}
          userNames={userNames}
          styles={styles}
        />
      );
    }
    return <p>Unsupported game type</p>;
  };

  // Custom styles for react-select matching Selection.jsx
  const selectStyles = {
    container: (base) => ({
      ...base,
      width: "100%",
      maxWidth: "100%",
      margin: "10px auto",
    }),
    control: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
      border: "1px solid #cbd5e0",
      padding: "4px",
      fontSize: "clamp(13px, 2.5vw, 15px)",
      "&:hover": {
        borderColor: "#3498db",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#3498db"
        : state.isFocused
        ? "#ebf5ff"
        : "white",
      color: state.isSelected ? "white" : "#4a5568",
      padding: "10px 15px",
      fontSize: "clamp(13px, 2.5vw, 15px)",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#a0aec0",
      fontSize: "clamp(13px, 2.5vw, 15px)",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "clamp(13px, 2.5vw, 15px)",
    }),
  };

  return (
    <div className="App">
      <HeaderMain pageType="ViewGame" />
      <div
        style={{
          ...styles.container,
          margin: window.innerWidth <= 768 ? "15px" : "20px auto",
          padding:
            window.innerWidth <= 480
              ? "15px"
              : window.innerWidth <= 768
              ? "18px"
              : "20px",
        }}
      >
        <h1 style={styles.sectionTitle}>
          View Game Records
          <div style={styles.titleUnderline}></div>
        </h1>

        <div style={styles.selectionStep}>
          <div>
            <span style={styles.stepNumber}>1</span>
            <span style={styles.stepTitle}>Select Sport Type</span>
          </div>
          <div style={styles.selectWrapper}>
            <Select
              options={sportsOptions}
              onChange={(selectedOption) =>
                setSelectedSport(selectedOption.value)
              }
              styles={selectStyles}
              placeholder="Choose a sport..."
              isSearchable
            />
          </div>
        </div>

        {!selectedSport && (
          <p style={styles.infoMessage}>
            Please select a sport to view your game records
          </p>
        )}

        {selectedSport && noRecordsMessage && (
          <p style={styles.noRecordsMessage}>{noRecordsMessage}</p>
        )}

        {gameRecords.length > 0 && (
          <div style={{ marginTop: "20px" }}>
            {gameRecords.map((record) => (
              <div
                key={record.recordId}
                style={styles.gameRecordCard}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 15px rgba(0,0,0,0.1)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 10px rgba(0,0,0,0.05)";
                }}
              >
                <div style={styles.gameRecordHeader}>
                  <h3 style={styles.gameRecordTitle}>
                    {record.sports_name} Match
                  </h3>
                  <span style={styles.gameRecordId}>
                    Record ID: {record.recordId}
                  </span>
                </div>

                <div style={styles.gameRecordInfo}>
                  <p style={{ fontSize: "clamp(13px, 2.5vw, 15px)" }}>
                    <span style={styles.infoLabel}>Arena:</span>
                    <span style={styles.infoValue}>
                      {record.Arena_name || "Guest Arena"}
                    </span>
                  </p>
                  <p style={{ fontSize: "clamp(13px, 2.5vw, 15px)" }}>
                    <span style={styles.infoLabel}>Created:</span>
                    <span style={styles.infoValue}>
                      {new Date(record.created_at).toLocaleString()}
                    </span>
                  </p>
                </div>

                <div style={{ textAlign: "right" }}>
                  <button
                    onClick={() => handleViewDetails(record)}
                    style={styles.viewButton}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#2980b9";
                      e.currentTarget.style.boxShadow =
                        "0 6px 8px rgba(52, 152, 219, 0.4)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "#3498db";
                      e.currentTarget.style.boxShadow =
                        "0 4px 6px rgba(52, 152, 219, 0.3)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && selectedRecord && (
        <div style={styles.modalOverlay} onClick={handleModalBackdropClick}>
          <div style={styles.modalContent}>
            {/* Fixed Header */}
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>
                {selectedRecord.sports_name} Match Details
              </h2>
              <button
                onClick={closeModal}
                style={styles.closeButton}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#c0392b";
                  e.currentTarget.style.boxShadow =
                    "0 4px 8px rgba(231, 76, 60, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#e74c3c";
                  e.currentTarget.style.boxShadow =
                    "0 2px 6px rgba(231, 76, 60, 0.3)";
                }}
                title="Close"
              >
                ×
              </button>
            </div>

            {/* Scrollable Content */}
            <div style={styles.modalBody}>
              <div style={styles.modalDetailsGrid}>
                <p style={{ fontSize: "clamp(13px, 2.5vw, 15px)" }}>
                  <span style={styles.infoLabel}>Sport:</span>
                  <span style={styles.infoValue}>
                    {selectedRecord.sports_name}
                  </span>
                </p>
                <p style={{ fontSize: "clamp(13px, 2.5vw, 15px)" }}>
                  <span style={styles.infoLabel}>Arena:</span>
                  <span style={styles.infoValue}>
                    {selectedRecord.Arena_name || "Guest Arena"}
                  </span>
                </p>
                {selectedRecord.booking_date && selectedRecord.booking_time && (
                  <p style={{ fontSize: "clamp(13px, 2.5vw, 15px)" }}>
                    <span style={styles.infoLabel}>Booking:</span>
                    <span style={styles.infoValue}>
                      {new Date(selectedRecord.booking_date).toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }
                      )}{" "}
                      at {selectedRecord.booking_time}
                    </span>
                  </p>
                )}
                <p style={{ fontSize: "clamp(13px, 2.5vw, 15px)" }}>
                  <span style={styles.infoLabel}>Created:</span>
                  <span style={styles.infoValue}>
                    {new Date(selectedRecord.created_at).toLocaleString()}
                  </span>
                </p>
              </div>

              <h3 style={styles.sectionHeading}>Match Details</h3>

              <div style={{ marginBottom: "15px", overflowX: "auto" }}>
                {renderGameDetails(selectedRecord.results)}
              </div>
            </div>

            {/* Fixed Footer */}
            <div style={styles.modalFooter}>
              <button
                onClick={closeModal}
                style={styles.closeFooterButton}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#5a6c7d";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#718096";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewGame;
